document.addEventListener("DOMContentLoaded", function () {
    const mediaQuery = window.matchMedia("(min-width: 768px) and (max-width:1118px)");

    if (mediaQuery.matches) {
        setTimeout(() => {
            const pushboxes = document.querySelectorAll('.columnmarker .component-pushbox');
            let maxHeight = 0;
            pushboxes.forEach(pushbox => {
                const height = pushbox.offsetHeight;
                if (height > maxHeight) {
                    maxHeight = height;
                }
            });

            pushboxes.forEach(pushbox => {
                pushbox.style.setProperty('height', maxHeight + 'px', 'important');
            });

        }, 700);
    }
});
jQuery(function () {
    $('.section.vspace-sm').each(function () {
        if ($(this).find('.promoComponentRedsign').length) {
            $(this).addClass('promoComponent');
        }
    });
    // Select all the promoComponent elements under .main_content
    const promoComponents = document.querySelectorAll('.main_content .promoComponent');
    if (promoComponents.length > 0) {
        // Get the last promoComponent
        const lastPromoComponent = promoComponents[promoComponents.length - 1];
        const lastPromoSection = lastPromoComponent.closest('.section');

        if (lastPromoSection) {
            lastPromoSection.classList.add('marginBottom_lastPromo');
        }
    }
    async function setAlignment() {
        await delay(1000);
        setbottomAlignment();
    }

    equal_height_cards();


    setAlignment();
    equal_height_text_elements();
});
$(window).on('load', function () {

    async function setAlignment() {
        await delay(1000);
        setbottomAlignment();
    }
    equal_height_cards();


    setAlignment();
    equal_height_text_elements();
});
$(window).resize(function () {
    async function setAlignment() {
        await delay(1000);
        setbottomAlignment();
    }
    equal_height_cards();


    setAlignment();
    equal_height_text_elements();
});

function delay(ms) {
    return new Promise(resolve =>
        setTimeout(resolve, ms));
}

function equal_height_cards() {
    $(".gapincard").not('.gapinInfocard').find('.Promobox--SingleCard > .component-pushbox').height("unset");
    $('.Promobox--SingleCard').height("unset");
    if ($(window).width() > 767) {
        $(".gapincard").not('.gapinInfocard').each(function () {
            var maxHeight = 0;
            $(this).find('.Promobox--SingleCard > .component-pushbox').each(function () {
                if ($(this).parent().hasClass("promofullWidthImage")) { } else {
                    var height = $(this).outerHeight(true);
                    if (height > maxHeight) {
                        maxHeight = height;
                    }
                }

            });
            $(this).find('.Promobox--SingleCard > .component-pushbox').each(function () {
                $(this).height(maxHeight);
            });
        });
        $(".gapin-promolist").each(function () {
            var maxHeightpromo = 0;
            $(this).find('.Promobox--SingleCard > .component-pushbox').each(function () {
                var height = $(this).outerHeight(true);
                if (height > maxHeightpromo) {
                    maxHeightpromo = height;
                }
            });

            $(this).find('.Promobox--SingleCard > .component-pushbox').each(function () {
                $(this).height(maxHeightpromo);

            });

        });

    }


}

function setbottomAlignment() {
    if ($(window).width() > 767) {
        $(".Promobox--SingleCard > .component-pushbox").each(function () {


            var $pushbox = $(this),
                totalHeight = $(this).outerHeight(true),
                contentHeight = 0,
                difference = 0;
            // Calculate content height
            $pushbox.find(".promocontent-div").children()
                .filter(function () {
                    return $(this).css("position") !== "absolute";
                }).each(function () {
                    contentHeight += $(this).outerHeight(true);

                });

            // Calculate difference
            difference = Math.ceil(totalHeight - contentHeight);

            if (contentHeight > 0 && difference > 0) {
                $(this).find(".pushbox-button").css("margin-top", difference);
                //    $(this).find(".js-align-bottom").css("margin-top", difference);
            }

        });
    }
}


function equal_height_text_elements() {
    // Reset the height of promo-heading, promo-desc, and promo-subheading
    $(".gapincard").not('.gapinInfocard').find('.Promobox--SingleCard .promo-heading, .Promobox--SingleCard .promo-desc, .Promobox--SingleCard .promo-subheading').css("height", "unset");


    if ($(window).width() > 767) {
        $(".gapincard").not('.gapinInfocard').each(function () {
            // Equal height for promo-heading
            var maxHeadingHeight = 0;
            //$(this).find('.Promobox--SingleCard .promo-heading').each(function () {
            //    var height = $(this).outerHeight(true);
            //    if (height > maxHeadingHeight) {
            //        maxHeadingHeight = height;
            //    }
            //});
            //$(this).find('.Promobox--SingleCard .promo-heading').each(function () {
            //    $(this).css("height", maxHeadingHeight);
            //});

            // Equal height for promo-desc
            var maxDescHeight = 0;
            $(this).find('.Promobox--SingleCard .promo-desc').each(function () {
                var height = $(this).outerHeight(true);
                if (height > maxDescHeight) {
                    maxDescHeight = height;
                }
            });
            $(this).find('.Promobox--SingleCard .promo-desc').each(function () {
                $(this).css("height", maxDescHeight);
            });

            // Equal height for promo-subheading
            var maxSubheadingHeight = 0;
            //$(this).find('.Promobox--SingleCard .promo-subheading').each(function () {
            //    var height = $(this).outerHeight(true);
            //    if (height > maxSubheadingHeight) {
            //        maxSubheadingHeight = height;
            //    }
            //});
            //$(this).find('.Promobox--SingleCard .promo-subheading').each(function () {
            //    $(this).css("height", maxSubheadingHeight);
            //});

            $(this).find('.CTA_button_primary').each(function () {
                var $current = $(this);
                var hasButtonInSiblings = $(this).siblings().find('.pushbox-button').length > 0;

                if (!hasButtonInSiblings) {
                    $current.find('.js-align-bottom').css("margin-top", "0");
                }
            });
        });
    }
}



jQuery(function () {
    $(document).on('keydown', function (event) {
        if (event.key === 'Enter' || event.keyCode === 13) {
            // Get the currently focused element
            var focusedElement = $(document.activeElement);
            focusedElement.click();

        }
    });
});



//final working
jQuery(function () {
    let $slider = $('.slider-wrapper');
    let currentIndex = 0; // Initializing currentIndex
    let sliderDots = $('.slick-dots li');
    let leftArrow = $('#left-arrow');
    let rightArrow = $('#right-arrow');

    if ($slider.length) {
       
        if ($slider.hasClass('slick-initialized')) {
            $slider.slick('unslick'); // Destroy the existing instance
        }

        // console.log("Initializing Slick slider...");
        $slider.slick({
            slidesToShow: 3,
            slidesToScroll: 1,
            dots: true,
            arrows: true,
            prevArrow: '#left-arrow',
            nextArrow: '#right-arrow',
            appendDots: '.slider-dots-container',  // Append the dots into the container
            responsive: [
                { breakpoint: 1118, settings: { slidesToShow: 2 } },
                { breakpoint: 576, settings: { slidesToShow: 1 } }
            ]
        });
       
        // Function to highlight the dots of the visible slides
        function highlightVisibleDots() {
            // Get the current slide elements
            var visibleSlides = $slider.find('.slick-slide.slick-active');

            // Get all dots
            var dots = $('.slick-dots li');

            // Reset all dots to the default state
            dots.removeClass('slick-active');

            // Highlight the dots that correspond to the visible slides
            visibleSlides.each(function() {
                var slideIndex = $(this).data('slick-index'); // Get the index of the slide
                dots.eq(slideIndex).addClass('slick-active'); // Highlight the corresponding dot
            });
        }

        // Trigger the highlight function after each slide change
        $slider.on('afterChange', function(event, slick, currentSlide) {
            highlightVisibleDots();
            currentIndex = currentSlide;  // Update the current index when the slide changes
            updateArrows();
        });

        // Initial highlight when the slider is first initialized
        highlightVisibleDots();
        updateArrows(); // Initialize arrow states

        // Function to update the arrow states
        function updateArrows() {
            // Update the left arrow state
            if (currentIndex === 0) {
                leftArrow.html(`
                    <svg width="15" height="24" viewBox="0 0 15 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M14.2371 0.324281C13.9054 -0.0376023 13.3688 -0.0995422 12.9677 0.153266L12.8243 0.262852L0.824275 11.2628C0.439949 11.6151 0.397246 12.1929 0.696166 12.5953L0.824275 12.7372L12.8243 23.7371C13.2314 24.1103 13.864 24.0828 14.2371 23.6757C14.5689 23.3138 14.584 22.7738 14.2973 22.3962L14.1757 22.2628L2.98 12L14.1757 1.73716C14.5376 1.40543 14.5995 0.868768 14.3467 0.467672L14.2371 0.324281Z" fill="#E6E7E8"/>
                    </svg>
                `);
                leftArrow.css('pointer-events', 'none');
            } else {
                leftArrow.html(`
                    <svg width="15" height="24" viewBox="0 0 15 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M14.2371 0.324281C13.9054 -0.0376023 13.3688 -0.0995422 12.9677 0.153266L12.8243 0.262852L0.824275 11.2628C0.439949 11.6151 0.397246 12.1929 0.696166 12.5953L0.824275 12.7372L12.8243 23.7371C13.2314 24.1103 13.864 24.0828 14.2371 23.6757C14.5689 23.3138 14.584 22.7738 14.2973 22.3962L14.1757 22.2628L2.98 12L14.1757 1.73716C14.5376 1.40543 14.5995 0.868768 14.3467 0.467672L14.2371 0.324281Z" fill="#8E9093"/>
                    </svg>
                `);
                leftArrow.css('pointer-events', 'auto');
            }

            // Update the right arrow state
            if (currentIndex === sliderDots.length - 1) {
                rightArrow.html(`
                    <svg width="15" height="24" viewBox="0 0 15 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M0.762852 0.324281C1.09458 -0.0376023 1.63124 -0.0995422 2.03234 0.153266L2.17573 0.262852L14.1757 11.2628C14.5601 11.6151 14.6028 12.1929 14.3038 12.5953L14.1757 12.7372L2.17573 23.7372C1.76861 24.1103 1.13604 24.0828 0.762852 23.6757C0.431125 23.3138 0.415997 22.7738 0.702664 22.3962L0.824281 22.2628L12.02 12L0.824281 1.73716C0.462398 1.40543 0.400458 0.868768 0.653266 0.467672L0.762852 0.324281Z" fill="#E6E7E8"/>
                    </svg>
                `);
                rightArrow.css('pointer-events', 'none');
            } else {
                rightArrow.html(`
                    <svg width="15" height="24" viewBox="0 0 15 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M0.762852 0.324281C1.09458 -0.0376023 1.63124 -0.0995422 2.03234 0.153266L2.17573 0.262852L14.1757 11.2628C14.5601 11.6151 14.6028 12.1929 14.3038 12.5953L14.1757 12.7372L2.17573 23.7372C1.76861 24.1103 1.13604 24.0828 0.762852 23.6757C0.431125 23.3138 0.415997 22.7738 0.702664 22.3962L0.824281 22.2628L12.02 12L0.824281 1.73716C0.462398 1.40543 0.400458 0.868768 0.653266 0.467672L0.762852 0.324281Z" fill="#8E9093"/>
                    </svg>
                `);
                rightArrow.css('pointer-events', 'auto');
            }
        }


        // Left arrow click handler
        leftArrow.on('click', function() {
            if (currentIndex > 0) {
                currentIndex--;
                $slider.slick('slickPrev'); // Move to previous slide
            }
        });

        // Right arrow click handler
        rightArrow.on('click', function() {
            if (currentIndex < sliderDots.length - 1) {
                currentIndex++;
                $slider.slick('slickNext'); // Move to next slide
            }
        });

    } else {
        console.error("Error: .slider-wrapper not found!");
    }
});


jQuery(function () {
    // Function to adjust the height of .promo-content within slick slider
    function adjustPromoContentHeight() {
        // Reset the height first to avoid cumulative heights from previous runs
        $('.slick-track .promo-content').height('auto');

        // Find the highest height of .promo-content within the slick container
        var maxHeight = 0;
        $('.slick-track .promo-content').each(function() {
            var contentHeight = $(this).outerHeight();
            if (contentHeight > maxHeight) {
                maxHeight = contentHeight;
            }
        });

        // Apply the max height to all .promo-content elements within slick slider
        $('.slick-track .promo-content').height(maxHeight);
    }

    // Adjust the height when the document is ready
    adjustPromoContentHeight();

    // Adjust the height when the window is resized
    $(window).on('resize', function() {
        adjustPromoContentHeight();
    });

    // You might also need to trigger this function after a slick slider update
    $('.slick-slider').on('afterChange', function(event, slick, currentSlide) {
        adjustPromoContentHeight();
    });
});
